import { CommonModule } from '@angular/common';
import { Component, OnDestroy, inject } from '@angular/core';

import { of } from 'rxjs';

import { DropdownComponent } from '@camelot/form-input';
import { InputDropdown } from '@camelot/form-model';
import { TranslatePipe } from '@camelot/translation';
import { CamTranslationService } from '@camelot/translation';
import { ButtonComponent, TrigramComponent } from '@camelot/ui';
import { CamBaseComponent, JoinPipe, StopPropagationDirective } from '@camelot/utils';

import { CAM_AUTH_TOKEN } from '../../services/auth.service';
import { CamPermissionsService } from '../../services/permissions.service';
import { CamTranslationUser } from '../../translation.service';

@Component({
  selector: 'cam-user-menu',
  templateUrl: './menu-user.component.html',
  styleUrls: ['./menu-user.component.scss'],
  imports: [
    CommonModule,
    TranslatePipe,
    ButtonComponent,
    TrigramComponent,
    JoinPipe,
    StopPropagationDirective,
    DropdownComponent,
  ],
})
export class MenuUserComponent extends CamBaseComponent implements OnDestroy {
  public readonly _permissionsService = inject(CamPermissionsService);

  get roles() {
    return this._permissionsService.roles;
  }

  get getFirstLetter() {
    return this.authService.firstLetter;
  }

  public authService = inject(CAM_AUTH_TOKEN);
  public translateService = inject(CamTranslationService);

  public language = new InputDropdown<string>({
    label: '',
    options: of([
      { id: 'fr', name: 'Français' },
      { id: 'nl', name: 'Nederlands' },
      { id: 'en', name: 'English' },
      { id: 'es', name: 'Español' },
    ]),
  });

  constructor() {
    super();
    CamTranslationUser.getInstance();

    this.language.value = this.translateService.getLanguage();
    this.language.createFormControl();

    this._registerSubscription(this.language.changeValue$.subscribe(value => this.translateService.use(value)));
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.language.destroy();
  }

  public login() {
    this.authService.login();
  }

  public logout() {
    this.authService.logout();
  }
}
